import * as v from "valibot";

export const WCStoreCartAddItemArgsItemsSchema = v.object({
  /** Variation attribute name. */
  attribute: v.string(),
  /** Variation attribute value. */
  value: v.string(),
});

export const WCStoreCartAddItemArgsSchema = v.object({
  /** The basket item product or variation ID. */
  id: v.optional(v.number()),
  /** Quantity of this item to add to the basket. */
  quantity: v.optional(v.number()),
  /** Chosen attributes (for variations). */
  variation: v.optional(v.array(WCStoreCartAddItemArgsItemsSchema)),
});
